(() => {
  const desktopMedia = window.matchMedia('(min-width: 900px)');

  document.querySelectorAll('[data-amore-catalog]').forEach((catalog) => {
    const grid = catalog.querySelector('[data-amore-catalog-grid]');
    const desktopDensityButtons = catalog.querySelectorAll('[data-amore-density]');
    const mobileDensityButton = catalog.querySelector('button[data-amore-mobile-density]');
    const desktopFilterButton = catalog.querySelector('[data-amore-desktop-filter-button]');
    const mobileFilterButton = catalog.querySelector('[data-amore-mobile-filter-button]');
    const mobileFilter = catalog.querySelector('[data-amore-mobile-filter]');
    const mobileFilterClose = catalog.querySelector('[data-amore-mobile-filter-close]');
    const filterScrim = catalog.querySelector('[data-amore-filter-scrim]');
    let mobileDensity = 2;
    let lastTrigger = null;

    const resetGridForViewport = () => {
      if (!grid) return;

      if (desktopMedia.matches) {
        grid.removeAttribute('data-amore-mobile-density-current');
      } else {
        grid.style.removeProperty('grid-template-columns');
        grid.style.removeProperty('row-gap');
        grid.removeAttribute('data-amore-density-current');
        desktopDensityButtons.forEach((button) => {
          const isDefault = button.dataset.amoreDensity === '4';
          button.classList.toggle('is-active', isDefault);
          button.setAttribute('aria-pressed', String(isDefault));
        });
        grid.dataset.amoreMobileDensityCurrent = String(mobileDensity);
      }
    };

    desktopDensityButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (!grid || !desktopMedia.matches) return;

        const density = button.dataset.amoreDensity;
        const gaps = { 2: '104px', 4: '56px', 8: '36px' };
        grid.style.gridTemplateColumns = `repeat(${density}, minmax(0, 1fr))`;
        grid.style.rowGap = gaps[density];
        grid.dataset.amoreDensityCurrent = density;
        desktopDensityButtons.forEach((candidate) => {
          const isActive = candidate === button;
          candidate.classList.toggle('is-active', isActive);
          candidate.setAttribute('aria-pressed', String(isActive));
        });
      });
    });

    mobileDensityButton?.addEventListener('click', () => {
      if (!grid) return;

      mobileDensity = mobileDensity === 3 ? 1 : mobileDensity + 1;
      grid.dataset.amoreMobileDensityCurrent = String(mobileDensity);
      const nextDensity = mobileDensity === 3 ? 1 : mobileDensity + 1;
      mobileDensityButton.querySelector('i').textContent = String(nextDensity);
    });

    // FILTER-01 (17.09.2026): одна панель фильтра на всех ширинах. На компьютере
    // «Filter» открывает её справа (стили — в sections/amore-catalog.liquid),
    // клик мимо панели и Esc закрывают. Строка категорий на компьютере снята.
    const setFilter = (open, trigger) => {
      if (!mobileFilter) return;
      mobileFilter.hidden = !open;
      [mobileFilterButton, desktopFilterButton].forEach((button) => {
        button?.setAttribute('aria-expanded', String(open));
      });
      if (filterScrim) filterScrim.hidden = !(open && desktopMedia.matches);
      document.documentElement.classList.toggle('amore-catalog-filter-open', open);
      if (open) {
        lastTrigger = trigger || null;
        mobileFilterClose?.focus({ preventScroll: true });
      } else if (lastTrigger) {
        lastTrigger.focus({ preventScroll: true });
        lastTrigger = null;
      }
    };

    desktopFilterButton?.addEventListener('click', () => setFilter(true, desktopFilterButton));
    mobileFilterButton?.addEventListener('click', () => setFilter(true, mobileFilterButton));
    mobileFilterClose?.addEventListener('click', () => setFilter(false));
    filterScrim?.addEventListener('click', () => setFilter(false));

    mobileFilter?.addEventListener('click', (event) => {
      if (event.target.closest('a')) setFilter(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileFilter && !mobileFilter.hidden) {
        setFilter(false);
      }
    });

    desktopMedia.addEventListener('change', () => {
      resetGridForViewport();
      setFilter(false);
    });
    resetGridForViewport();

  });
})();
